import UserReducer from "./slices/user/slice";
import { combineReducers } from "@reduxjs/toolkit";

const combinedReducer = combineReducers({
  admin: UserReducer,
});

export default combinedReducer;
